import React, { useState, useEffect, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import webapplogo from "../assest/sidebarlogi.png";
import { IoPeopleOutline, IoBriefcaseOutline, IoRadioOutline, IoPersonOutline, IoLogOutOutline } from "react-icons/io5";
import { LuLayoutDashboard } from "react-icons/lu";

const Sidebar = () => {
  const location = useLocation();
  const [selected, setSelected] = useState("");

  // Memoize the menu items to prevent unnecessary re-renders
  const menuItems = useMemo(() => [
    {
      title: "Overview",
      icon: <LuLayoutDashboard size={24} />,
      path: "/dashboard/overview",
    },
    {
      title: "My Campaigns",
      icon: <IoRadioOutline size={24} />,
      path: "/dashboard/my-campaigns",
    },
    {
      title: "Target Users",
      icon: <IoPeopleOutline size={24} />,
      path: "/dashboard/target-users",
    },
  ], []);

  const navigate = useNavigate();

  const HandleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("organizationid");
    localStorage.removeItem("version");
    localStorage.removeItem("isLoggedIn");

    navigate("/");
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const currentItem = menuItems.find((item) => item.path === currentPath);
    if (currentItem) {
      setSelected(currentItem.title);
    }
  }, [location.pathname, menuItems]); 

  return (
    <aside className="sidebar pb-4">
      <div className="space-y-2">
        <div className="logo">
          <img src={webapplogo} alt="Logo" />
        </div>
        {menuItems.map((item, index) => (
          <Link
            key={index}
            to={item.path}
            onClick={() => setSelected(item.title)}
            className={`flex items-center gap-3 font-medium px-4 py-3 ${
              selected === item.title
                ? "w-[90%] bg-red-500 text-white rounded-r-full"
                : "text-black"
            } hover:bg-red-500 hover:text-white hover:w-[90%] rounded-r-full`}
          >
            {item.icon}
            <span className="w-full">{item.title}</span>
          </Link>
        ))}
      </div>

      <div className="space-y-2">
        <Link
          to="/myorganization"
          onClick={() => setSelected("My Organization")}
          className={`flex items-center gap-3 font-medium px-4 py-3 ${
            selected === "My Organization"
              ? "w-[90%] bg-red-500 text-white rounded-r-full"
              : "text-black"
          } hover:bg-red-500 hover:text-white hover:w-[90%] rounded-r-full`}
        >
          <IoBriefcaseOutline size={24} />
          <span className="w-full">My Organization</span>
        </Link>

        <Link
          to="/profile"
          onClick={() => setSelected("My Profile")}
          className={`flex items-center gap-3 font-medium px-4 py-3 ${
            selected === "My Profile"
              ? "w-[90%] bg-red-500 text-white rounded-r-full"
              : "text-black"
          } hover:bg-red-500 hover:text-white hover:w-[90%] rounded-r-full`}
        >
          <IoPersonOutline size={24} />
          <span className="w-full">My Profile</span>
        </Link>

        <div
          className={`flex items-center gap-3 font-medium px-4 py-3 border-0 bg-transparent hover:bg-red-500 hover:text-white hover:w-[90%] rounded-r-full cursor-pointer`}
        >
          <IoLogOutOutline size={24} />
          <span onClick={HandleLogout} className="w-full">
            LogOut
          </span>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
